import classNames from "classnames";
import { MapGiftImage } from "@/components/atoms/MapGiftImage";
import { BgRadialBlur } from "@/components/atoms/BgRadialBlur";
import localFont from "next/font/local";
import { VETTED_PLACES_WORLDWIDE } from "@/constants";
import { PorangeButton } from "@/components/atoms/PorangeButton";
import { SocialProof } from "@/components/molecules/SocialProof";
import { PorangeText } from "@/components/atoms/PorangeText";
import AppStoreLogo from "@/components/atoms/AppStoreLogo";
import PlayStoreLogo from "@/components/atoms/PlayStoreLogo";
import { useEffect, useMemo, useState } from "react";
import { createBranchLink } from "@/api";
import { useQuizDataContext } from "@/context/QuizDataContextProvider";
import { track } from "@/utils/mixpanel";
import { MixpanelEvents, MixpanelProps } from "@/constants/mixpanel";
import { pushGtmEvent } from "@/utils/google-tag-manager";
import { GtmEvents } from "@/constants/google-tag-manager";
const montFont = localFont({ src: "../../fonts/Mont-Bold.otf" });

export const InAppQuizResultsScreen = ({ isTransitioning }) => {
    const [link, setLink] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const { area } = useQuizDataContext();

    const formattedArea = useMemo(() => {
        return area ? `in ${area}` : "worldwide";
    }, [area]);

    useEffect(() => {
        import("@/utils/branch")
            .then((mod) => {
                mod.initBranch(async (data) => {
                    const link = await createBranchLink({
                        withSale: true,
                        branchData: data,
                        referringLinkUrl: data.referring_link,
                    });

                    setLink(link);
                });
            });
    }, []);


    useEffect(() => {
        // Start with opacity 0, then fade in after a brief delay
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 50);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div
            className={classNames(
                "relative bg-blue-900 w-screen h-dvh p-0",
                "transition-opacity duration-500",
                {
                    "opacity-0": isTransitioning || !isVisible,
                    "opacity-100": !isTransitioning && isVisible,
                }
            )}>
            <BgRadialBlur color="porange" />
            <BgRadialBlur color="orange" />
            <div
                className={classNames({
                    "relative z-20 flex flex-col items-center justify-between": true,
                    'w-full h-dvh text-white': true,
                })}
            >
                <div className="flex flex-col items-center justify-center text-center mt-32">
                    <MapGiftImage />
                    <h1 className={classNames(montFont.className, {
                        'mt-4 mb-6 text-xl leading-[30px] text-[20px]': true,
                    })}>
                        Your results are ready!
                    </h1>
                    <h2 className={classNames(montFont.className, "text-[20px]")}>
                        {VETTED_PLACES_WORLDWIDE} <PorangeText>gluten-free</PorangeText> places
                        <br />
                        <PorangeText>vetted daily</PorangeText> {formattedArea}.
                    </h2>
                </div>
                <div className="mb-6 flex flex-col items-center gap-2">
                    <PorangeButton disabled={!link} onClick={() => {
                        if (link) {
                            track(MixpanelEvents.WEB_2_APP_END_QUIZ_DOWNLOAD_CLICKED);
                            window.open(link, '_blank');
                        }
                    }}>
                        <div className="flex justify-between items-center w-full">
                            <div>DOWNLOAD APP</div>
                            <div className="flex gap-2">
                                <AppStoreLogo color="white" size={24} className="-mt-0.5" />
                                <PlayStoreLogo color="white" size={24} />
                            </div>
                        </div>
                    </PorangeButton>
                    <SocialProof
                        position="bottom"
                        showNoise={false}
                        text="Join 12k+ in our GF community" />
                </div>
            </div>
        </div >
    );
};
